import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import VidyardEmbed from '@vidyard/embed-code';

@Component({
  selector: 'vex-time-challenge-video',
  templateUrl: './time-challenge-video.component.html',
  styleUrls: ['./time-challenge-video.component.scss']
})
export class TimeChallengeVideoComponent implements OnInit {
  video;
  miniSpinnerPlay: boolean = false;
  currentLang: string;

  constructor(public guiService: GuiService, public translate: TranslateService) { }

  ngOnInit() {
    this.guiService.showSpinner = false;
    if(sessionStorage.getItem('selectedTimeChallengeVideo')){
      this.currentLang = this.translate.currentLang.toUpperCase()
      this.video = JSON.parse(sessionStorage.getItem('selectedTimeChallengeVideo'));
      console.debug('selected video', this.video)
    }else{
      this.guiService.goTo('main/on-demand/time_challenge')
    }
  }

  showVideo() {
    const placeholderImage = document.querySelector('img.vidyard-player-embed');
    placeholderImage.setAttribute('src', `https://play.vidyard.com/${this.video.videoId[this.currentLang]}.jpg`)
    placeholderImage.setAttribute('data-uuid', this.video.videoId[this.currentLang])

    this.miniSpinnerPlay = true;
    let ref = this;

    setTimeout(() => {
      VidyardEmbed.api.renderDOMPlayers()
    const players = VidyardEmbed.api.getPlayersByUUID(this.video.videoId[this.currentLang]);
    const playerIndex = players.length - 1
    console.debug(players)
    players[playerIndex].ready();
    players[playerIndex].on('ready', function () {
      console.debug('PLAYER READY')
      players[playerIndex].pause();
      players[playerIndex].play()
    })

    players[playerIndex].on('play', function () {
      setTimeout(() => {
        players[playerIndex].toggleFullscreen()
        console.debug('PLAYER IN PLAY IN FULLSCREEN')
      }, 1500);

    })

    players[playerIndex].on('pause', function () {
      console.debug('PLAYER PAUSED')
    })

    players[playerIndex].on()
    }, 100);

    setTimeout(() => {
      ref.miniSpinnerPlay = false;
    }, 2000);
  }

  downloadPdf(){
    this.guiService.goToExternalLink(this.video.pdf[this.translate.currentLang.toUpperCase()]);
  }

}

